"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PROPOSAL_STATUS = void 0;
const gql_1 = require("../../../__generated__/gql");
exports.PROPOSAL_STATUS = (0, gql_1.gql)(`
   mutation ProposalStatus($proposal: ProposalStatusInput!) {
      proposalStatus(proposal: $proposal) {
      success
      error
    }}
  `);
